import { post } from '../util/secure_fetch.js';

export async function addFavorite(slug) {
  return post(getAddFavoriteEndpoint(slug));
}

export async function removeFavorite(slug) {
  return post(getRemoveFavoriteEndpoint(slug));
}

export async function toggleFavorite(slug, shouldAdd) {
  if (shouldAdd) {
    await addFavorite(slug);
  } else {
    await removeFavorite(slug);
  }
}

function getAddFavoriteEndpoint(slug) {
  return `/fonts/${slug}/typographic_favorites`;
}

function getRemoveFavoriteEndpoint(slug) {
  return `/fonts/${slug}/typographic_favorites/destroy`;
}
